function FormatDate(originalDate) {
    if (!originalDate) {
      return originalDate;
    }
  
    const [year, month, day] = originalDate.split("-");
    return `${day}/${month}/${year}`;
  }
  
export { FormatDate };